module.exports = __webpack_public_path__ + "static/media/dont-panic.4b1f131d.jpg";